export const sortByLastOccurenceAt = (a, b) =>
  new Date(b.get('startedAt')) - new Date(a.get('startedAt'))

export const sortByLastOccurenceAtJS = (a, b) => new Date(b.startedAt) - new Date(a.startedAt)

export const sortOccurenceByStartedAt = (a, b) => new Date(b.startedAt) - new Date(a.startedAt)

export const sortByOrder = (a, b) => a.order - b.order

export const sortByKeptAt = (a, b) => new Date(a.keptAt) - new Date(b.keptAt)



// WEBPACK FOOTER //
// ./src/utils/sort.js